var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.301,
    height: 58.301,
    viewBox: "0 0 58.301 58.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_230",
    x: 0,
    y: 0,
    width: 58.301,
    height: 58.301,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13228",
    "data-name": "Group 13228",
    transform: "translate(5114.65 -823.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5114.65, 823.35)",
    filter: "url(#Ellipse_230)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230-2",
    "data-name": "Ellipse 230",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(9.15 6.15)",
    fill: "#fff",
    stroke: "rgba(59,89,153,0.5)",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M44.948,29.811H42.742V37.89H39.4V29.811H37.812V26.972H39.4V25.134a3.133,3.133,0,0,1,3.371-3.371l2.475.01v2.756h-1.8a.68.68,0,0,0-.709.774v1.671h2.5Z",
    transform: "translate(-5127.375 820.37)",
    fill: "#3b5999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicoon);
export default __webpack_public_path__ + "static/media/facebookicoon.aaf2b4c09c9fc3f272e25731cbb41bfe.svg";
export { ForwardRef as ReactComponent };